var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tes-tr',{attrs:{"column-components":_vm.columnComponents}})}
var staticRenderFns = []

export { render, staticRenderFns }